import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

import { useTelegramBackButton } from '@common/hooks';
import { AuthProvider } from '@common/providers/AuthProvider';
import { useTabbar } from '@common/providers/useTabbar';
import { Page } from '@common/ui/Page';

import { Report, type ReportProps } from '@widgets/dating/components';

const reportSearchSchema = z.object({
  profileId: z.coerce.string().min(1),
  type: z.ostring(),
  matchId: z.coerce.string().optional(),
});

export const Route = createFileRoute('/dating/report')({
  component: Component,
  validateSearch: (search) => reportSearchSchema.parse(search),
});

export default function Component() {
  const tabbar = useTabbar();
  useTelegramBackButton({ to: 'back' });
  const { profileId, type, matchId } = Route.useSearch();

  useEffect(() => {
    tabbar.setShowNavigation(false);
  }, []);

  return (
    <AuthProvider>
      <Page>
        <Report
          profileId={profileId}
          type={type as ReportProps['type']}
          matchId={matchId}
        />
      </Page>
    </AuthProvider>
  );
}
